/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Color_Definitions_Color_DefinitionsInputs */

const en_tables_color_definitions_color_definitions = /** @type {(inputs: Tables_Color_Definitions_Color_DefinitionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definitions Color Definitions`)
};

const de_tables_color_definitions_color_definitions = /** @type {(inputs: Tables_Color_Definitions_Color_DefinitionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definitions Farbe Definitions`)
};

/**
* | output |
* | --- |
* | "Definitions Color Definitions" |
*
* @param {Tables_Color_Definitions_Color_DefinitionsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_color_definitions_color_definitions = /** @type {((inputs?: Tables_Color_Definitions_Color_DefinitionsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Color_Definitions_Color_DefinitionsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_color_definitions_color_definitions(inputs)
	return de_tables_color_definitions_color_definitions(inputs)
});